import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M12.003 17.926a1.013 1.013 0 0 1-.667-.254L2.532 9.567a.869.869 0 0 1-.209-.284.81.81 0 0 1 0-.672.869.869 0 0 1 .21-.283.986.986 0 0 1 .666-.254c.25 0 .49.091.666.254l8.138 7.503 8.138-7.503a.986.986 0 0 1 .666-.254c.25 0 .49.091.667.254a.835.835 0 0 1 .276.613c0 .23-.1.451-.276.614L12.67 17.66a.938.938 0 0 1-.304.196.997.997 0 0 1-.363.07Z" }, null, -1), r = [
  n
];
function a(s, l) {
  return e(), t("svg", c, [...r]);
}
const _ = { render: a };
export {
  _ as default,
  a as render
};
